import React, { useEffect } from "react";
import right from "../../assets/right.png";
import vidImage from "../../assets/vidImage.png";
import bg_ourApp from "../../assets/bg_ourApp.png";
import android from "../../assets/android.png";
import apple from "../../assets/apple.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideo } from "../../redux/videoSlice";

const OurApp = () => {
  const { t, i18n } = useTranslation();

  const { language } = i18n;

  const dispatch = useDispatch();

  const { video, status, error } = useSelector(
    (state) => state.video
  );


  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchVideo());
    }
  }, [status, dispatch]);

  const fullVideoUrl = video ? `https://service.samoolah.com${video}` : null;

  return (
    <div className="my-20 px-20 max-lg:px-5 relative">
      <div className="text-center">
        <h2 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
          {t("DOWNLOAD_OUR_APP")}
        </h2>
        <p className="text-[#737E91] text-lg mt-3">
          {t("EXPERIENCE_CONVENIENCE")}
        </p>
      </div>
      <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10">
        <div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p
              className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"
                }`}
            >
              {t("EASY_SERVICE_BOOKING")}
            </p>
          </div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p
              className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"
                }`}
            >
              {t("SEAMLESS_PRODUCT_PURCHASES")}
            </p>
          </div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p
              className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"
                }`}
            >
              {t("REQUEST_PREVIEWS")}
            </p>
          </div>
          <div className="flex items-center mt-7">
            <img src={right} className="w-[45px]" />
            <p
              className={`text-[#14294F] text-xl ${language == "en" ? "ml-5" : "mr-5"
                }`}
            >
              {t("EXCLUSIVE_DEALS")}
            </p>
          </div>
        </div>
        <div>
          <img
            src={bg_ourApp}
            className={`absolute top-5 ${language == "en" ? "-right-20" : "-left-20"
              } max-lg:right-0 w-[360px] h-[450px] max-lg:w-[280px] z-0`}
          />
          {/* <div className="relative z-10">
            <video
              controls
              width="500px"
              poster={vidImage}
              className="flex mx-auto rounded-2xl bg-black w-[420px] h-[260px] max-lg:w-full mt-5"
            >
              <source src={vidImage} type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <button className="bg-[#FE9B71] text-white rounded-full px-6 py-3 mt-5 flex mx-auto">
              {t("WATCH_DEMO")}
            </button>
          </div> */}
          <div className="relative z-10">
            <video
              controls
              width="500px"
              // poster={vidImage}
              className="flex mx-auto rounded-2xl bg-black w-[420px] h-[260px] max-lg:w-full mt-5"
              src={fullVideoUrl}
            >
              {/* <source src={fullVideoUrl} type="video/mp4" />
              Your browser does not support the video tag. */}
            </video>

            {/* <button className="bg-[#FE9B71] text-white rounded-full px-6 py-3 mt-5 flex mx-auto">
              {t("WATCH_DEMO")}
            </button> */}
          </div>

        </div>
      </div>
      <div>
        <h3 className="text-[#F16622] text-center text-2xl mt-6">
          {t("AVAILABLE_ON")}
        </h3>
        <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-6 w-2/3 mx-auto lg:flex lg:justify-between">
          <div>
            <div className="bg-[#FCFBFA] rounded-2xl flex items-center border-2 border-[#EAA182] w-[330px] h-[90px] max-lg:w-full">
              <img src={android} className="w-[50px] mx-7 max-lg:mx-5" />
              <div className="text-[#3B3D42]">
                <p className="text-sm">{t("DOWNLOAD_NOW")}</p>
                <p className="text-2xl max-lg:text-lg font-semibold">
                  {t("GOOGLE_PLAY")}
                </p>
              </div>
            </div>
            <div className="flex mx-auto">
              <Link
                to="https://play.google.com/store/apps/details?id=com.dtag.samoolah.customer"
                className="bg-[#FE9B71] text-white rounded-full px-6 py-3 mt-5 mx-auto"
              >
                {t("DOWNLOAD_NOW")}
              </Link>
            </div>
          </div>
          <div>
            <div className="bg-[#FCFBFA] rounded-2xl flex items-center border-2 border-[#EAA182] w-[330px] h-[90px] max-lg:w-full">
              <img src={apple} className="w-[50px] mx-7 max-lg:mx-5" />
              <div className="text-[#3B3D42]">
                <p className="text-sm">{t("DOWNLOAD_NOW")}</p>
                <p className="text-2xl max-lg:text-lg font-semibold">
                  {t("APP_STORE")}
                </p>
              </div>
            </div>
            <div className="flex mx-auto">
              <Link
                to="https://apps.apple.com/sa/app/samoolah/id6478872148"
                className="bg-[#FE9B71] text-white rounded-full px-6 py-3 mt-5 mx-auto"
              >
                {t("DOWNLOAD_NOW")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApp;
